import { moment } from "utils"
import * as types from "../types/shiftCashier"

const initialState = {}

const shiftCashierReducer = (state = initialState, action) => {
  const object = { ...state }

  const cashierShift = object[action.accountId]

  switch (action.type) {
    case types.OPEN_SHIFT:
      object[action.accountId] = {
        _id: action.shiftId,
        queueNumbers: {},
        startAt: moment().toISOString(),
        startingCash: action.startingCash,
        paidIns: [],
        paidOuts: [],
        taxesAndCharges: 0,
        taxes: 0,
        charges: 0,
        refund: 0,
        discounts: 0,
        payments: {
          "نقدی": 0,
          "کارت بانکی": 0
        }
      }

      return object
    case types.ADD_PAID_IN:
      object[action.accountId] = {
        ...cashierShift,
        paidIns: [...cashierShift.paidIns, action.paidIn],
      }

      return object
    case types.ADD_PAID_OUT:
      object[action.accountId] = {
        ...cashierShift,
        paidOuts: [...cashierShift.paidOuts, action.paidOut],
      }

      return object
    case types.ADD_REFUND:
      object[action.accountId] = {
        ...cashierShift,
        refund:
          cashierShift.refund + action.totalRefund,
        taxesAndCharges:
          cashierShift.taxesAndCharges - action.taxRefund,
        discounts:
          cashierShift.discounts - action.discountRefund,
      }

      return object
    case types.ADD_NEW_SHIFT_ORDER: {
      const {
        taxes,
        charges,
        discounts,
        cashTypes
      } = action.newShiftOrder

      const newPayments = { ...cashierShift.payments }

      cashTypes.forEach(cashType => {
        const previousPayment =
          Number(newPayments[cashType.type]) || 0

        newPayments[cashType.type] =
          previousPayment + Number(cashType.amount)
      })

      object[action.accountId] = {
        ...cashierShift,
        payments: newPayments,
        discounts: cashierShift.discounts + discounts,
        taxesAndCharges: cashierShift.taxesAndCharges + taxes + charges,
      }

      return object
    }
    case types.CLEAR_SHIFT:
      delete object[action.accountId]

      return { ...object }
    case types.INCREASE_SHIFT_QUEUE_NUMBER:
      const newQueueNumber =
        Object.keys(cashierShift.queueNumbers).length + 1

      object[action.accountId] = {
        ...cashierShift,
        queueNumbers: {
          ...cashierShift.queueNumbers,
          [action.orderId]: newQueueNumber
        }
      }

      return { ...object }
    case types.UPDATE_SHIFT_QUEUE_NUMBERS:
      const queueNumber =
        cashierShift.queueNumbers[action.previousOrderId]

      delete cashierShift.queueNumbers[action.previousOrderId]

      object[action.accountId] = {
        ...cashierShift,
        queueNumbers: {
          ...cashierShift.queueNumbers,
          [action.newOrderId]: queueNumber
        }
      }

      return { ...object }
    default:
      return state
  }
}

export default shiftCashierReducer